import { baseApi, unwrapEnvelope } from '@/model/client';
import type {
  ListWorkspaceMembersResponse,
  MyPermissionsResponse,
} from '@/model/workspace/dto.generated';

export const MEMBER_PAGE_SIZE = 100;

const NO_CURSOR = '';

const workspaceEndpoints = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getWorkspaceMemberPages: build.infiniteQuery<
      ListWorkspaceMembersResponse,
      { workspaceId: string },
      string
    >({
      infiniteQueryOptions: {
        initialPageParam: NO_CURSOR,
        getNextPageParam: (lastPage): string | undefined =>
          lastPage.has_more && lastPage.next_cursor ? lastPage.next_cursor : undefined,
      },
      query: ({ queryArg, pageParam }) => ({
        url: `/api/workspaces/${queryArg.workspaceId}/members`,
        params: {
          limit: MEMBER_PAGE_SIZE,
          ...(pageParam === NO_CURSOR ? {} : { cursor: pageParam }),
        },
      }),
      transformResponse: (response: unknown) =>
        unwrapEnvelope<ListWorkspaceMembersResponse>(response),
      providesTags: ['workspaces'],
    }),
    getProjectPermissions: build.query<MyPermissionsResponse, { projectId: string }>({
      query: ({ projectId }) => `/api/projects/${projectId}/permissions`,
      providesTags: ['permissions'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetWorkspaceMemberPagesInfiniteQuery, useGetProjectPermissionsQuery } =
  workspaceEndpoints;
